import { isTruthy } from './utils';
import { ParkingSpaceInformationVehicleType } from './types/types';

export const RIDESHARE_ALLOWED_TYPES = [
  ParkingSpaceInformationVehicleType.RIDESHARE,
  ParkingSpaceInformationVehicleType.TAXI,
  ParkingSpaceInformationVehicleType.COMMERCIAL,
];
export const DEFAULT_MAX_TIME_MS = 5 * 60 * 1000;

export type AppMode = 'backendless' | 'real' | 'demo';

export function getConfig() {
  const mode = (process.env.REACT_APP_MODE as AppMode) || 'demo';

  const CONSECUTIVE_EVENTS_THRESHOLD = parseInt(
    process.env.REACT_APP_CONSECUTIVE_EVENTS_THRESHOLD || '1',
  );

  return {
    MODE: mode,
    URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3004',
    AUTH_ENABLED: isTruthy(process.env.REACT_APP_AUTH_ENABLED),
    IS_PLAYWRIGHT: isTruthy(process.env.REACT_APP_IS_PLAYWRIGHT) || false,
    ML_SORTATION_URL: process.env.REACT_APP_ML_SORTATION_URL || '',
    CONSECUTIVE_EVENTS_THRESHOLD,
  };
}
